import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-bone" data-id="element-0" data-mp="28u5ysp4wd9dw">
      <MetaPixel data-id="element-1" data-mp="28t4l0cwhy8sh" />
      <CountdownBar data-id="element-2" data-mp="28sl511qepuh3" />
      <main data-id="element-3" data-mp="28s30zixi6bym">
        <Hero data-id="element-4" data-mp="23vkvggucm9l8" />
        <Marquee data-id="element-5" data-mp="23w4fq47h1a2f" />
        <StatsBar data-id="element-6" data-mp="23ujksdh8vp41" />
        <Difference data-id="element-7" data-mp="23v2r0wxj8p28" />
        <Recognize data-id="element-8" data-mp="23ti7e2craqj5" />
        <WhatsInside data-id="element-9" data-mp="3ik7ekc2063oj" />
        <InsidePages data-id="element-10" data-mp="3iiwdijzxza14" />
        <Bonuses data-id="element-11" data-mp="3ijfv1zlojwem" />
        <Offer data-id="element-12" data-mp="3ihv048vgebg8" />
        <Guarantee data-id="element-13" data-mp="3mljat0fdtn5p" />
        <Testimonials data-id="element-14" data-mp="3ml1397n9rmih" />
        <Faq data-id="element-15" data-mp="3mkhofzsx1e8o" />
      </main>
      <Footer data-id="element-16" data-mp="3mjq45l4rr2xp" />
    </div>;
}